// extracted by mini-css-extract-plugin
export default {"controlBox":"_ControlBoxCentered_controlBox__d-oSb"};